import ActionsIndex from "../actions/ActionsIndex";
import { useParams } from "react-router-dom";

const ApproveTab = () => {
  const { id } = useParams();
  return <ActionsIndex blockId={id} />;
};
export default ApproveTab;
